<template>
  <div class="table-responsive">
    <table>
      <thead>
        <tr>
          <th>Forma de pago</th>
          <th>Valor</th>
          <th>Plazo</th>
          <th>Unidad de tiempo</th>
          <th class="ta-right">
            <button @click="agregarFormaPago" class="btn-success" type="button">
              <i class="fa fa-plus"></i>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in modelValue" :key="index">
          <td>
            <div :class="{'select2--disabled' : disabled}" class="select2-field">
              <v-select
                :tooltip="row.selectedFormaPago !== undefined && row.selectedFormaPago !== null && row.selectedFormaPago.nombre!==''?row.selectedFormaPago.nombre:'Seleccione...'"
                label="nombre"
                :options="formasPago"
                v-model="row.selectedFormaPago"
                :id="'formaPago' + index"
                placeholder="Seleccione..."
              ></v-select>
              <span
                v-if="erroresFormulario.hasOwnProperty('formasPago.' + index + '.selectedFormaPago.id_forma_pago')"
                class="helper-text text-danger"
                slot="helper"
              >
                <strong>{{ erroresFormulario['formasPago.' + index + '.selectedFormaPago.id_forma_pago'][0] }}</strong>
              </span>
            </div>
          </td>
          <td>
            <input-field
              :disabled="disabled"
              vMoney
              @keyup.native="$emit('updatedFormaPago')"
              :format="money"
              v-model="row.valor"
              :id="'valor' + index"
              placeholder="$ #,###.##"
            >
              <span
                v-if="erroresFormulario.hasOwnProperty('formasPago.' + index + '.valor')"
                class="helper-text text-danger"
                slot="helper"
              >
                <strong>{{ erroresFormulario['formasPago.' + index + '.valor'][0] }}</strong>
              </span>
            </input-field>
          </td>
          <td>
            <input-field
              @keyup.native="$emit('updatedFormaPago')"
              :disabled="disabled"
              vMoney
              :format="int"
              v-model="row.plazo"
              :id="'plazo' + index"
              placeholder="Plazo de pago"
            >
              <span
                v-if="erroresFormulario.hasOwnProperty('formasPago.' + index + '.plazo')"
                class="helper-text text-danger"
                slot="helper"
              >
                <strong>{{ erroresFormulario['formasPago.' + index + '.plazo'][0] }}</strong>
              </span>
            </input-field>
          </td>
          <td>
            <div :class="{'select2--disabled' : disabled}" class="select2-field">
              <v-select
                @input="$emit('updatedFormaPago')"
                :tooltip="row.unidad_tiempo!==''?row.unidad_tiempo:'Seleccione...'"
                :id="'unidadTiempo' + index"
                placeholder="Seleccione..."
                :options="tiposUnidad"
                v-model="row.unidad_tiempo"
              ></v-select>
              <span
                v-if="erroresFormulario.hasOwnProperty('formasPago.' + index + '.unidad_tiempo')"
                class="helper-text text-danger"
                slot="helper"
              >
                <strong>{{ erroresFormulario['formasPago.' + index + '.unidad_tiempo'][0] }}</strong>
              </span>
            </div>
          </td>
          <td>
            <button
              :disabled="disabled"
              @click="eliminarFormaPago(index)"
              class="btn-danger btn--text"
              type="button"
            >
              <i class="fa fa-trash-o"></i>
            </button>
          </td>
        </tr>
        <tr>
          <td v-show="modelValue.length === 0" colspan="5">
            <strong>No se ha agregado forma de pago alguna.</strong>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: function() {
        return [];
      },
      required: false
    },
    formasPago: {
      required: true,
      type: Array
    },
    errores: {
      type: Object,
      required: true
    },
    totalComprobante: {
      required: true
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    tiposUnidad: {
      required: true,
      type: Array
    }
  },
  data: function() {
    return {
      modelValue: this.value,
      erroresFormulario: this.errores,
      money: money,
      int: int
    };
  },
  methods: {
    agregarFormaPago: function() {
      this.modelValue.push({
        selectedFormaPago: null,
        valor: "",
        plazo: "",
        unidad_tiempo: ""
      });
    },
    eliminarFormaPago: function(index) {
      let that = this;
      swal({
        title: "¿Desear eliminar esta forma de pago?",
        text: "Esta acción requiere de confirmación.",
        type: "question",
        showCancelButton: true,
        confirmButtonText: "Eliminar",
        cancelButtonText: "No"
      }).then(result => {
        if (result.value) that.modelValue.splice(index, 1);
        that.$emit("updatedFormaPago");
      });
    }
  },
  watch: {
    value: function(value) {
      this.modelValue = value;
    },
    errores: function(value) {
      this.erroresFormulario = value;
    },
    totalComprobante: function(value) {
      if (this.modelValue.length === 0) {
        this.modelValue.push({
          selectedFormaPago: null,
          valor: value,
          plazo: "",
          unidad_tiempo: "días"
        });
      } else if (this.modelValue.length === 1) {
        let formaPago = this.modelValue[0];
        if (formaPago.selectedFormaPago === null) {
          let selectedFormapago = null;
          for (let i = 0; i < this.formasPago.length; i++)
            if (this.formasPago[i].id_forma_pago === "20") {
              selectedFormapago = this.formasPago[i];
              break;
            }
          formaPago.selectedFormaPago = selectedFormapago;
        }
        formaPago.valor = value;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/TablaFormaPago.vue